const SERVICES_ACCOUNT_TRANSFER_KEYS = ['service_account_transfer']
const SERVICES_NETWORK_KEYS = ['service_page']

export const servicesEntries = [
  {
    reducerKey: 'services/list',
    sagaKey: 'servicesListSaga',
    routeKeys: SERVICES_ACCOUNT_TRANSFER_KEYS,
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-account-transfer" */ 'modules/Services/NetworksList/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-account-transfer" */ 'modules/Services/NetworksList/store/saga'
      ),
  },
  {
    reducerKey: 'services/account-transfer',
    sagaKey: 'servicesAccountTransferSaga',
    routeKeys: [...SERVICES_ACCOUNT_TRANSFER_KEYS, ...SERVICES_NETWORK_KEYS],
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-account-transfer" */ 'modules/Services/TransferAccount/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-account-transfer" */ 'modules/Services/TransferAccount/store/saga'
      ),
  },
]

export const financeEntries = [
  {
    reducerKey: 'services/account-transfer',
    sagaKey: 'servicesAccountTransferSaga',
    routeKeys: ['billing/account-transfer-payment'],
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-account-transfer" */ 'modules/Services/TransferAccount/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-account-transfer" */ 'modules/Services/TransferAccount/store/saga'
      ),
  },
]
